<template>
  <div
    class="app-wrapper"
    style="height: auto; min-height: calc(100% - 44.8px);"
    :class="classObj"
  >
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    ></div>
    <div
      class="sidebar-container"
      :class="currentSIPPModule === 'overview' ? 'sidebarless' : ''"
      :style="device !== 'mobile' ? 'top: 65px; ' : 'top: 80px;'"
    >
      <el-row class="rowTop2">
        <div
          v-if="sidebar.opened"
          style="display: flex; width: 100%; justify-content: flex-start; align-items: center; flex-direction: row;"
        >
          <!-- <img style="display: flex; width: 35px; height: 35px; margin-right: 12px;" :src="profilePicture"/> -->
          <span class="primaryTextColor" style="text-align: left; font-size: 14px;"
            >Hi, {{ username }}</span
          >
        </div>
      </el-row>
      <el-row class="rowTop3">
        <div
          v-if="sidebar.opened && companies.length > 1"
          style="display: flex; width: 100%; justify-content: center; align-items: flex-start; flex-direction: column; margin-bottom: 10px;"
        >
          <el-button style="height: 40px;" @click="switchCompany()" type="starbucks" size="medium" round>
            <svg-icon icon-class="repeat_solid" style="margin-right: 5px;"/> Company
          </el-button>
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: center; align-items: center;" v-if="branchData">
          <span
            v-if="branchData.regionId && sidebar.opened"
            class="primaryTextColor"
            style="width: 100%; text-align: left; font-size: 20px; margin-bottom: 4px; margin-top: 0px;"
            >{{ branchData.regionId.companyId && branchData.regionId.companyId.name ? branchData.regionId.companyId.name : "-" }}</span
          >
          <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; margin-bottom: 20px;">
            <el-tag
              v-if="branchData.relation && sidebar.opened"
              type="beige"
              style="height: 100%; text-align: left; font-size: 14px; margin-top: 0px; padding: 4px; line-height: 14px;"
              >{{ branchData.relation.role }}</el-tag
            >
          </div>
          <!-- <span
            v-if="branchData.relation && sidebar.opened"
            class="primaryTextColor"
            style="width: 100%; text-align: left; font-size: 14px; margin-bottom: 10px; margin-top: 0px;"
            >{{ branchData.relation.role }}</span
          > -->
          <!-- <span
            v-if="branchData.region && sidebar.opened"
            class="primaryTextColor"
            style="width: 100%; text-align: left; font-size: 14px; margin-bottom: 4px;"
            >{{ branchData.region.name }}</span
          >
          <span
            v-if="sidebar.opened"
            class="primaryTextColor"
            style="width: 100%; text-align: left; font-size: 14px;"
            >{{ branchData.name }}</span
          > -->
        </div>
      </el-row>
      <sidebar></sidebar>
    </div>
    <div style="display: flex; flex-direction: column;" class="main-container" :class="currentSIPPModule === 'overview' ? 'sidebarless' : ''">
      <navbar></navbar>
      <app-main :nextBranch="nextBranch" :notificationSocket="notificationSocket" :imsteknobumiSocket="imsteknobumiSocket" :sippSocket="sippSocket" :nimsSocket="nimsSocket"></app-main>
      <div v-if="device !== 'mobile'" class="footerClass" style="margin-top: 120px;">
        <div
          style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
        >
          <p style="width: 400px; text-align: center; font-size: 12px;">
            Copyright © {{ year }} {{ appname }}. All rights reserved.
          </p>
        </div>
        <div
          style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
        >
          <p style="width: 400px; text-align: center; font-size: 12px;">
            <span style="cursor: pointer;" @click="legal">Legal Terms</span>
            |
            <span style="cursor: pointer;" @click="privacy"
              >Privacy Policy</span
            >
            |
            <span style="cursor: pointer;" @click="cookie"
              >Cookie Policy</span
            >
          </p>
        </div>
      </div>
      <div v-else class="footer2Class" style="margin-top: 120px;">
        <div
          style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
        >
          <div
            style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
          >
            <p style="width: 100%; text-align: center; font-size: 12px;">
              Copyright © {{ year }} {{ appname }}. All rights reserved.
            </p>
          </div>
          <div
            style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
          >
            <p style="width: 100%; text-align: center; font-size: 12px;">
              <span style="cursor: pointer;" @click="legal"
                >Legal Terms</span
              >
              |
              <span style="cursor: pointer;" @click="privacy"
                >Privacy Policy</span
              >
              |
              <span style="cursor: pointer;" @click="cookie"
                >Cookie Policy</span
              >
            </p>
          </div>
        </div>
      </div>
      <!-- <div v-if="bossLoading" style="display: flex; width: 100%; position: absolute; top: 50px; justify-content: center; align-items: center;">
        <img style="display: flex; position: relative; width: 320px;" :src="boss"/>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "@/mixin/ResizeHandler";
import SocketIO from 'socket.io-client'
import moment from 'moment'

export default {
  name: "layout",
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  props: {
    switchCompany: {
      type: Function
    },
    nextBranch: {
      type: Function
    },
    // notificationSocket: {
    //   type: Object
    // }
  },
  data() {
    return {
      notificationSocket: null,
      imsteknobumiSocket: null,
      sippSocket: null,
      nimsSocket: null,
      appname: process.env.APP_NAME,
      year: "",
    };
  },
  mounted() {
    this.year = moment().format("YYYY");
    // console.log(this.$store.state.user.branchData)
    // console.log("layout")
    // this.nextBranch()
    // console.log('layout branchSelected', this.$store.state.app.branchSelected)
    if (this.$store.state.app.branchSelected) {
      // this.notificationSocket = SocketIO.connect(process.env.BASE_API, {
      //   path: '/serviceNotifications-admin-socket.io',
      //   query: `token=${this.token}`
      // })
      // this.notificationSocket.on('connect', () => {
      //   console.log('connected')
      //   this.notificationSocket.emit('join', this.$store.state.app.branchSelected)
      // })
      // // console.log("this.$store.state.app", this.$store.state.app)
      // this.notificationSocket.on('newNotification', (data) => {
      //   console.log('app', data)
      //   this.$store.dispatch('GetUnreadMessages', this.$store.state.app.branchSelected)
      // })
      if (this.features.imsteknobumi) {
        this.imsteknobumiSocket = SocketIO.connect(process.env.BASE_API, { path: '/imsteknobumi-admin-socket.io', query: { token: this.token, branchId: this.$store.state.app.branchSelected } } )
        this.imsteknobumiSocket.on('connect', () => {
          // this.socketId = this.socket.id
          // console.log('connect:', this.socketId)
          console.log('imsteknobumi connected')
        })
        this.sippSocket.on('disconnect', () => {
          console.log('imsteknobumi disconnected')
        })
        this.imsteknobumiSocket.on('newRequestedWHPartNotification', async (data) => {
          console.log('app', data)
          this.$store.dispatch('GetRequestedWHPartNotifications', { branchId: this.$store.state.app.branchSelected, feature: 'imsteknobumi' })
        })
        this.imsteknobumiSocket.on('newPurchaseOrderNotification', async (data) => {
          console.log('app', data)
          this.$store.dispatch('GetPurchaseOrderNotifications', { branchId: this.$store.state.app.branchSelected, feature: 'imsteknobumi' })
        })
      }
      if (this.features.sipp) {
        this.sippSocket = SocketIO.connect(process.env.BASE_API, { path: '/sipp-admin-socket.io', query: { token: this.token, branchId: this.$store.state.app.branchSelected } } )
        this.sippSocket.on('connect', () => {
          // this.socketId = this.socket.id
          // console.log('connect:', this.socketId)
          console.log('sipp connected')
        })
        this.sippSocket.on('disconnect', () => {
          console.log('sipp disconnected')
        })
        this.sippSocket.on('newRequestedWHPartNotification', async (data) => {
          console.log('app', data)
          this.$store.dispatch('GetRequestedWHPartNotifications', { branchId: this.$store.state.app.branchSelected, feature: 'sipp' })
        })
        this.sippSocket.on('newPurchaseOrderNotification', async (data) => {
          console.log('app', data)
          this.$store.dispatch('GetPurchaseOrderNotifications', { branchId: this.$store.state.app.branchSelected, feature: 'sipp' })
        })
      }
      // if (this.features.nims) {
      //   this.nimsSocket = SocketIO.connect(process.env.BASE_API, { path: '/nims-admin-socket.io', query: { token: this.token, branchId: this.$store.state.app.branchSelected } } )
      //   this.nimsSocket.on('connect', () => {
      //     // this.socketId = this.socket.id
      //     // console.log('connect:', this.socketId)
      //     console.log('nims connected')
      //   })
      //   this.nimsSocket.on('disconnect', () => {
      //     console.log('nims disconnected')
      //   })
      //   this.nimsSocket.on('newRequestedWHPartNotification', async (data) => {
      //     console.log('app', data)
      //     this.$store.dispatch('GetRequestedWHPartNotifications', { branchId: this.$store.state.app.branchSelected, feature: 'nims' })
      //   })
      //   this.nimsSocket.on('newPurchaseOrderNotification', async (data) => {
      //     console.log('app', data)
      //     this.$store.dispatch('GetPurchaseOrderNotifications', { branchId: this.$store.state.app.branchSelected, feature: 'nims' })
      //   })
      // }
    }
  },
  beforeDestroy() {
    // this.notificationSocket.disconnect()
    this.imsteknobumiSocket.disconnect()
    this.sippSocket.disconnect()
    // this.nimsSocket.disconnect()
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    token() {
      return this.$store.state.user.token;
    },
    device() {
      return this.$store.state.app.device;
    },
    features() {
      return this.$store.state.user.features;
    },
    branchData() {
      return this.$store.state.user.branchData
        ? this.$store.state.user.branchData
        : {};
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    },
    username() {
      return this.$store.state.user.username;
    },
    awakRole() {
      return this.$store.state.user.awakRole;
    },
    profilePicture() {
      return this.$store.state.user.profilePicture;
    },
    device() {
      return this.$store.state.app.device;
    },
    companies() {
      return this.$store.state.user.companies.sort((a, b) => {
        if (a.relationId && b.relationId) {
          if (a.relationId.name < b.relationId.name) {
            return -1
          }
          if (a.relationId.name > b.relationId.name) {
            return 1
          }
        }

        return 0
      });
    },
    currentSIPPModule() {
      return this.$store.state.user.currentSIPPModule
    }
  },
  filters: {
    roleFilter(val) {
      if (val !== "none") {
        return val[0].toUpperCase() + val.substring(1);
      } else {
        return "Manager";
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("CloseSideBar", { withoutAnimation: false });
    },
    legal() {
      window.open('/legal')
    },
    privacy() {
      window.open('/privacy')
    },
    cookie() {
      window.open('/cookie')
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";
@import "src/styles/mixin.scss";
.app-wrapper {
  color: var(--primary-color);
  @include clearfix;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.rowTop2 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  height: 76px;
  background-color: var(--bg-color);
}
.rowTop3 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  // height: 108px;
  background-color: var(--bg-color);
}
</style>


// WEBPACK FOOTER //
// src/views/admin/layout/Layout.vue